import React from 'react';
import { imageGlobalUrl } from '../../utils/api'
export default class CourceList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }
    }
    render() {
        const _this = this;
        let courceList = _this.props.courceList;
        return (
            <div className="data-list">
                {
                    _this.props.isLoading
                        ? <div className="loading-anim">
                            <div className="border out"></div>
                            <div className="border in"></div>
                            <div className="border mid"></div>
                        </div>
                        : <ul className="data-list">
                            {
                                courceList.length > 0
                                    ? courceList.map((item, index) => {
                                        return (
                                            <li className="list-item" key={index} onClick={_this.playCource.bind(_this, item)}>
                                                <img src={imageGlobalUrl + item.iconUrl} />
                                                <div className="inner-info">
                                                    <p className="info-author">
                                                        <span className="author">{item.expertName}</span>
                                                        <span>{item.title}</span>
                                                    </p>
                                                    <p className="info-title">{item.courseName}</p>
                                                    <p>
                                                        {
                                                            item.viewType == 1
                                                                ? '价格'
                                                                : null
                                                        }
                                                        {
                                                            item.viewType == 2
                                                                ? <span className="mark-update">{item.reVideoCount}个内容更新</span>
                                                                : null
                                                        }
                                                        {
                                                            item.viewType == 3
                                                                ? <span className="chapter">第{item.chapterCh}章节已播放{item.playProgress + '%'}</span>
                                                                : null
                                                        }

                                                    </p>
                                                </div>
                                            </li>
                                        )
                                    })
                                    : <li className="list-item" style={{ justifyContent: 'center', alignItems: 'center' }}>暂无数据</li>
                            }
                            {
                                _this.props.hasMore
                                    ? <li className="list-limit" style={{ textAlign: 'center', fontSize: '14px', paddingBottom: '8px', color: '#999' }}>加载中...</li>
                                    : <li className="list-limit" style={{ textAlign: 'center', fontSize: '14px', paddingBottom: '8px', color: '#999' }}>-我是有底线的-</li>
                            }
                        </ul>
                }
            </div>
        );
    }
    /**
     * [playCource 播放课程]
     * @author zhangzhaohui
     * @DateTime 2020-04-30T16:37:15+0800
     * @return   {[type]}                 [description]
     */
    playCource(item) {
        const _this = this;

        _this.props.history.push({ pathname: '/play', search: '?courseID=' + item.courseID + '&chapter=' + item.chapter + '&progress=' + item.playProgress });
    }

}


